import UserAvatar from "../user/UserAvatar";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/user/userSlice";
import { Badge, Breadcrumbs, Button } from "@mui/material";
import { useNavigate } from "react-router";
import React, { useEffect } from "react";
import MessageIcon from "@mui/icons-material/Message";
import { conversationListSlice, retrieveConversationList, selectConversationList } from "../../redux/conversation/conversationListSlice";
import { useAppDispatch } from "../../app/hooks";
import { LoadState } from "../../redux/common";
import { routeConversation } from "../../routes/conversation";
import { Home } from "@mui/icons-material";
import { ConversationStatus, ConversationUserStatus } from "../../redux/conversation/conversationSlice";

export interface BreadcrumbInfo {
    label: React.ReactNode;
    href?: string;
    el?: React.ReactNode;
}

export interface TopBarProps {
    title?: React.ReactNode;
    pageAvatar?: React.ReactNode;
    breadcrumbs?: BreadcrumbInfo[];
    topMenu?: React.ReactNode;
    leftEl?: React.ReactNode;
}

export function TopBar({ title, pageAvatar, breadcrumbs, topMenu, leftEl }: TopBarProps) {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const user = useSelector(selectUser);
    const conversationList = useSelector(selectConversationList);

    useEffect(() => {
        dispatch(retrieveConversationList({}));
    }, [user, conversationList]);
    useEffect(() => {
        if (!user.token) {
            dispatch(conversationListSlice.actions.logout());
        }
    }, [user.token]);

    const pageAvatarEl = pageAvatar ? pageAvatar : <></>;
    const titleEl = title ? title : <Box sx={{ flexGrow: 1 }}>Bem vindo</Box>;
    if (!breadcrumbs) {
        breadcrumbs = [];
    }

    const breadcrumbsView = breadcrumbs ?
        <Breadcrumbs separator="›" maxItems={2} aria-label="breadcrumb">
            <Button key="home" color="inherit" onClick={() => { navigate("/"); }}>Início</Button>
            {
                breadcrumbs.map((item, i) => {
                    if (item.el)
                        return item.el;

                    const href = item.href ? item.href : "#";
                    return <Button key={i} color="inherit" onClick={() => { navigate(href); }}>{item.label}</Button>;
                }
                )}
        </Breadcrumbs>
        : <></>;

    let messagesEl = <></>;
    if( conversationList.state.state === LoadState.Loaded && user.token ) {
        let hasUnread = false;
        for (const conversation of conversationList.list || []) {
            if(conversation.conversationStatus != ConversationStatus.ENABLED) {
                continue; // Skip silenced conversations
            }
            if(conversation.conversationUserStatus != ConversationUserStatus.ACTIVE) {
                continue; // Skip silenced conversations
            }
            // console.log("Conversation", conversation);
            if((conversation.lastReadMessageId || 0) < (conversation.lastNonSystemId || conversation.lastMessageId || 0)) {
                hasUnread = true;
                break;
            }
        }
        messagesEl = <>
            <Button
                key="messages"
                disabled={!user || !user.priza.info}
                color="inherit" variant='outlined' onClick={() => { navigate(routeConversation()); }}>
                <Badge color="error" 
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    badgeContent={hasUnread ? " " : undefined} 
                    overlap="circular">
                    <MessageIcon />
                </Badge>
            </Button>
        </>;
    }


    return (
    <Box key="top-bar" id="top-bar" sx={{ flexGrow: 1 }}>
        <AppBar position="static">
            <Toolbar>
                <Home sx={{ cursor: "pointer", mx: 1 }} onClick={() => { navigate("/"); }} />
                {topMenu}
                {pageAvatarEl}
                {titleEl}
                <Box sx={{ flexGrow: 1 }} />
                {leftEl}
                {messagesEl}
                <UserAvatar />
            </Toolbar>
        </AppBar>
        { breadcrumbsView }
    </Box >
  );
}
